import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 7329D294-805D-4843-AB03-B87C661C296A
 * name calendar-multiple-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-multiple-check.svg
 * tags
 * - Date / Time 
 */
export const CalendarMultipleCheckIcon = createSvgIcon(<><path d="M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M17.53,11.06L13.09,15.5L10.41,12.82L11.47,11.76L13.09,13.38L16.47,10L17.53,11.06M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21Z" /></>, 'CalendarMultipleCheckIcon');
export default CalendarMultipleCheckIcon